import React from 'react';
import type { Feature } from '@exiftrator/shared';
import { Button } from '@exiftrator/shared/components/ui';

function ShareButton() {
  const handleShare = async () => {
    if (!navigator.share) {
      console.error('Web Share API not available');
      return;
    }

    try {
      await navigator.share({
        title: 'Exiftrator - Image Metadata Editor',
        text: 'Check out this powerful image metadata editor!',
        url: window.location.href,
      });
    } catch (error) {
      // User cancelled or share failed
      if ((error as Error).name !== 'AbortError') {
        console.error('Share failed:', error);
      }
    }
  };

  return (
    <Button
      variant="secondary"
      size="sm"
      onClick={handleShare}
      title="Share this app"
    >
      Share
    </Button>
  );
}

export const shareButtonFeature: Feature = {
  id: 'share-button',
  name: 'Share Button',
  description: 'Share the app using Web Share API',
  platform: 'web',
  component: ShareButton,
  location: 'header',
  isAvailable: () => typeof navigator !== 'undefined' && 'share' in navigator,
};
